import { useState, useCallback } from 'react';
import { Table } from 'foundations-components/transitional/components/Table';
import { MilestoneTableColGroup } from './MilestoneTableColGroup';
import { MilestoneTableHeader } from './MilestoneTableHeader';
import { StyledTableBody } from './StyledTableBody';
import { AddMilestoneRow } from '../milestone/AddMilestoneTableRow';
import { CreateMilestoneRow } from '../milestone/CreateMilestoneTableRow';
import { MilestoneSkeletonRow } from '../milestone/MilestoneSkeletonRow';
import { MilestoneTableSizeProvider } from './MilestoneTableSizeContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SKELETON_COUNT = 5;
export const MilestoneTable = ({
  children,
  isLoading = false,
  size = 'full',
  hasSuggestions = false,
  onSubmit,
  readOnly
}) => {
  const [isCreating, setIsCreating] = useState(false);
  const handleSubmit = useCallback(title => {
    setIsCreating(false);
    onSubmit === null || onSubmit === void 0 || onSubmit(title);
  }, [onSubmit]);
  const handleAddMilestone = useCallback(() => {
    if (!isLoading) {
      setIsCreating(true);
    }
  }, [isLoading]);
  return /*#__PURE__*/_jsx(MilestoneTableSizeProvider, {
    value: size,
    children: /*#__PURE__*/_jsxs(Table, {
      bordered: false,
      responsive: false,
      condensed: true,
      hover: false,
      marginBlockEnd: "0",
      children: [/*#__PURE__*/_jsx(MilestoneTableColGroup, {
        hasSuggestions: hasSuggestions
      }), /*#__PURE__*/_jsx(MilestoneTableHeader, {
        hasSuggestions: hasSuggestions
      }), /*#__PURE__*/_jsxs(StyledTableBody, {
        children: [isLoading ? Array.from({
          length: SKELETON_COUNT
        }, (_, i) => /*#__PURE__*/_jsx(MilestoneSkeletonRow, {}, i)) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [children, !readOnly && isCreating && /*#__PURE__*/_jsx(CreateMilestoneRow, {
            onSubmit: handleSubmit,
            onCancel: () => setIsCreating(false)
          })]
        }), /*#__PURE__*/_jsx(AddMilestoneRow, {
          onAddMilestone: handleAddMilestone,
          readOnly: readOnly
        })]
      })]
    })
  });
};